import React, { useState } from "react";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Grid from "@material-ui/core/Grid";
import TableBody from "@material-ui/core/TableBody";
import List from "@material-ui/core/List";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import InputAdornment from "@material-ui/core/InputAdornment";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import Typography from "@material-ui/core/Typography";
import Menu from "@material-ui/core/Menu";
import Popover from "@material-ui/core/Popover";
import swal from "@sweetalert/with-react";
import Checkbox from "@material-ui/core/Checkbox";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { CircularProgress } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import InspectionPopup from "./inspectionPopup";
import ReplayIcon from "@material-ui/icons/Replay";
import BookIcon from "@material-ui/icons/Book";
import EditIcon from "@material-ui/icons/Edit";
import moment from "moment";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { useHistory } from "react-router-dom";
import dots from "../../Assets/dots.png";
import dotsH from "../../Assets/dotsH.png";
import GlobalApi from "./../../Global";
import Spinner from "./../../Global/Spinner2";
import Colors from "./../../Global/colors";
import EventIcon from "@material-ui/icons/Event";
import NoRecords from "./../../Global/NoRecords";
import refresh_token from "./../../Global/refresh_token";
import file from "../../Assets/file.png";
import share from "../../Assets/share.png";
import deleteIcon from "../../Assets/delete.png";
import pencil from "../../Assets/pencil.png";
import restore from "../../Assets/restore.png";
import restoreG from "../../Assets/restoreG.png";
import search from "../../Assets/search.png";
import add from "../../Assets/add.png";
import filter from "../../Assets/Filter_Icon.png";
import { KeyboardDatePicker } from "@material-ui/pickers";
import timetable from "../../Assets/timetable.png";
import { useSelector, useDispatch } from "react-redux";
import { getOverlappingDaysInIntervals } from "date-fns";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import help from '../../Assets/help_icon.png';
import helpAr from "../../Assets/help_icon_ar.png";
// import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import {useTranslation} from 'react-i18next';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}



const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },

  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: "green",
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: "green",
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  return "";
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "55vh",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 650,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  visuallyHidden: {
    border: 0,
    clip: " t(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function InspectionArchive() {
  const {t} = useTranslation();
  const language = useSelector((state) => state.languageReducer.language);
    let currentUser = useSelector((state) => state.userReducer.user);
  const classes = useStyles();
  const dispatch = useDispatch();
  let company = useSelector((state) => state.companyReducer.company);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [inspectionLoader, setInspectionLoader] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filterMenu1, setFilterMenu1] = React.useState(null);
  const [filterMenu2, setFilterMenu2] = React.useState(null);
  const [filterMenu3, setFilterMenu3] = React.useState(null);
  const [filterMenu4, setFilterMenu4] = React.useState(null);
  const [filterMenu5, setFilterMenu5] = React.useState(null);
  const [datesFilters, setDateFilters] = React.useState({
    today: false,
    yesterday: false,
    last7: false,
    last15: false,
    lastMonth: false,
    startFlag: false,
    endFlag: false,
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [startDate, setStartDate] = React.useState(new Date());
  const [endDate, setEndDate] = React.useState(moment());
  const [userFilter, setUserFilter] = useState("");
  const [templateFilter, setTemplateFilter] = useState("");
  const [siteFilter, setSiteFilter] = useState("");
  const [teamArr, setTeamArr] = useState([]);
  const [Assignees, setAssignees] = useState([]);
  const [sites, setSites] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState({
    Users: false,
    Templates: false,
    Sites: false,
  });
  const [selectedUser, setSelectedUsers] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [selectedAccess, setSelectedAccess] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [currentEditInspection, setCurrentEditInspection] = React.useState(
    null
  );
  const [currentEditRow, setCurrentEditRow] = React.useState({});

  const [rows, setRows] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  let history = useHistory();

  React.useEffect(
    () => {
      getInspection(true);
      getUsers();
      getTemplates();
      getSites();
    },
    [company?.id]
  );

  const headCells = [
    {
      id: "Title",
      numeric: false,
      disablePadding: true,
      label: <>{t("Name")}</>,
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "Template",
      numeric: false,
      disablePadding: false,
      label: <>{t("Template")}</>,
      borderLeft: true,
      borderRight: true,
    },
    {
      id: "Site",
      numeric: false,
      disablePadding: false,
      label: <>{t("Site")}</>,
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "Date",
      numeric: false,
      disablePadding: false,
      label: <>{t("Date")}</>,
      borderLeft: true,
      borderRight: true,
    },
    {
      id: "Score",
      numeric: false,
      disablePadding: false,
      label: <>{t("Score")}</>,
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "Status",
      numeric: false,
      disablePadding: false,
      label: <>{t("Status")}</>,
      borderLeft: true,
      borderRight: true,
    },
    {
      id: "Assigned To",
      numeric: false,
      disablePadding: false,
      label: <>{t("Assigned To")}</>,
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "Actions",
      numeric: false,
      disablePadding: false,
      label: <>{t("Actions")}</>,
      borderLeft: language=="ar" ? false : true,
      borderRight:  language=="ar" ? true : false,
    },
  ];
  
  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
  
    return (
      <TableHead>
        <TableRow>
          {/* <TableCell padding="checkbox">
            <Checkbox />
          </TableCell> */}
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.numeric === true ? "center" : (language =="ar" ? "right" :"left")}
              sortDirection={orderBy === headCell.id ? order : false}
              style={{
                paddingTop: "8px",
                padding: "8px",
                fontWeight: "bold",
                color: Colors.globalColor8,
                textTransform: "capitalize",
                borderTop: "1px solid #dadada",
                borderLeft: headCell.borderLeft ? "1px solid #dadada" : "none",
                backgroundColor: "#f2f2f2",
                borderRight: headCell.borderRight ? "1px solid #dadada" : "none",
              }}
            >
              {/* <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
                style={{textAlign:headCell.numeric === true ? "center" : "left"}}
              > */}
  
              {headCell.label}
  
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
              {/* </TableSortLabel> */}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  
  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };


  const handleScroll = (e) => {
    let currentRecords = rows.length;

    const bottom =
      e.target.scrollHeight - Math.ceil(e.target.scrollTop) ===
      e.target.clientHeight;
    const top = e.target.scrollTop == 0;
    if (bottom) {
      if (currentRecords < totalRecords) {
        if (filterApplied) {
          getMoreInspection(false);
        } else {
          getMoreInspection(true);
        }
      }
    }
  };

  const getUsers = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company.id,
    };
    console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_entity?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          let arr = [];
          response.data.map((item) => {
            let obj = {
              first_name: item.first_name,
              last_name: item.last_name,
              id: item.id,
              checked: false,
            };
            arr.push(obj);
          });
          console.log("users??????????????????????????????????", arr);
          setAssignees(arr);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();

          if (status) {
            // console.log("opopopop");
            getUsers();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  const getTemplates = async () => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    var params = {
      company_id: company.id,
      user_id: data.user_id,
    };
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi + "/TemplateShare/get_all_template_shares_for_user?" + query,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          console.log(res.data);
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            var template = { id: data.id, name: data?.title, checked: false };
            templateList.push(template);
          });

          console.log(
            "templateList??????????????????????????????????",
            templateList
          );
          setTemplates(templateList);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const getSites = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);

    let token = data.token;

    let params = { company_id: company.id };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let form = data.data;
        if (data.data.length > 0) {
          let arr = [];
          const data1 = data.data.map((value, index) => {
            value.Areas.map((area, i) => {
              area.Sites.map((sites, j) => {
                let obj = {
                  Site: sites?.title,
                  site_id: sites.id,
                  checked: false,
                };
                if (sites.status !== "deactivated") {
                  arr.push(obj);
                }
              });
            });
          });
          console.log("Sites??????????????????????????????????", arr);
          setSites(arr);
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  };

  const handleDone = (type) => {
    if (type == "Users") {
      if (selectedUser.length > 0) {
        setAppliedFilters({ ...appliedFilters, Users: true });
      } else {
        setAppliedFilters({ ...appliedFilters, Users: false });
      }
    } else if (type == "Templates") {
      if (selectedTemplates.length > 0) {
        setAppliedFilters({ ...appliedFilters, Templates: true });
      } else {
        setAppliedFilters({ ...appliedFilters, Templates: false });
      }
    } else if (type == "Sites") {
      if (selectedSites.length > 0) {
        setAppliedFilters({ ...appliedFilters, Sites: true });
      } else {
        setAppliedFilters({ ...appliedFilters, Sites: false });
      }
    }

    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getInspection();
    } else {
      setFilterApplied(false);
      getInspection(true);
    }
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const handleDone2 = async () => {
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getInspection();
    } else {
      setFilterApplied(false);
      getInspection(true);
    }
    setFilterMenu1(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(null);
  };

  const handleToday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: !datesFilters.today,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handleYesterday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: !datesFilters.yesterday,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle7Days = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: !datesFilters.last7,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle15Days = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: !datesFilters.last15,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(15, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle1Month = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: !datesFilters.lastMonth,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handleStartDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: true,
      endFlag: false,
      startDate: e.target.value,
    };
    console.log(_datesFilters);
    setDateFilters(_datesFilters);
  };

  const handleEndDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: true,
      endDate: e.target.value,
    };
    setDateFilters(_datesFilters);
  };

  const clearDatesFilter = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setFilterApplied(false);
    setDateFilters(_datesFilters);
    getInspection(true);
  };

  const clearUsersFilter = () => {
    setSelectedUsers([]);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      getInspection(false, [], selectedTemplates, selectedSites);
    } else {
      getInspection(true, [], selectedTemplates, selectedSites);
    }
  };

  const clearTemplatesFilter = () => {
    setSelectedTemplates([]);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      getInspection(false, selectedUser, [], selectedSites);
    } else {
      getInspection(true, selectedUser, [], selectedSites);
    }
  };

  const clearSitesFilter = () => {
    setSelectedSites([]);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      getInspection(false, selectedUser, selectedTemplates, []);
    } else {
      getInspection(true, selectedUser, selectedTemplates, []);
    }
  };

  const handleClose2 = () => {
    setAnchorEl(null);
  };

  const handleClick2 = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClick3 = (event) => {
    setFilterMenu1(event.currentTarget);
  };
  const handleClick4 = async (event) => {
    console.log("CLICK 4 >>>>>>>>>>>>>>>>> ", "ACCESS FILTER");
    setFilterMenu3(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu2(event.currentTarget);
  };
  const handleClick5 = async (event) => {
    console.log("CLICK 5 >>>>>>>>>>>>>>>>> ", "SHARED WITH FILTER");
    setFilterMenu2(null);
    setFilterMenu4(null);
    setFilterMenu5(null);
    setFilterMenu3(event.currentTarget);
  };

  const handleClick6 = async (event) => {
    console.log("CLICK 5 >>>>>>>>>>>>>>>>> ", "SHARED WITH FILTER");
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu5(null);
    setFilterMenu4(event.currentTarget);
  };
  const handleClick7 = async (event) => {
    console.log("CLICK 5 >>>>>>>>>>>>>>>>> ", "SHARED WITH FILTER");
    setFilterMenu2(null);
    setFilterMenu4(null);
    setFilterMenu3(null);
    setFilterMenu5(event.currentTarget);
  };

  const handleClose3 = () => {
    setFilterMenu1(null);
  };

  const handleClose4 = () => {
    setFilterMenu2(null);
  };

  const handleClose5 = () => {
    setFilterMenu3(null);
  };

  const handleClose6 = () => {
    setFilterMenu4(null);
  };

  const handleClose7 = () => {
    setFilterMenu5(null);
  };

  const open = Boolean(filterMenu1);
  const open2 = Boolean(filterMenu2);
  const open3 = Boolean(filterMenu3);
  const open4 = Boolean(filterMenu4);
  const open5 = Boolean(filterMenu5);

  // const onSelectUser = () => {
  //   setFilterMenu1(null);
  //   setFilterMenu2(null);
  //   setFilterMenu3(null);
  //   getTemplates();
  // };

  // const onSelectAccess = () => {
  //   setFilterMenu1(null);
  //   setFilterMenu2(null);
  //   setFilterMenu3(null);
  //   getTemplates(company);
  // };

  const selectUsers = (checked, item) => {
    const nextselectedUser = checked
      ? [...selectedUser, item.id]
      : selectedUser.filter((t) => t !== item.id);
    setSelectedUsers(nextselectedUser);
  };

  const selectTemplate = (checked, item) => {
    const nextselectedTemplate = checked
      ? [...selectedTemplates, item.id]
      : selectedTemplates.filter((t) => t !== item.id);
    setSelectedTemplates(nextselectedTemplate);
  };

  const selectSite = (checked, item) => {
    const nextselectedSite = checked
      ? [...selectedSites, item.site_id]
      : selectedSites.filter((t) => t !== item.site_id);
    setSelectedSites(nextselectedSite);
  };

  const getInspection = (
    reset = false,
    _selectedUser,
    _selectedTemplates,
    _selectedSites
  ) => {
    setInspectionLoader(true);
    console.log(
      "__________________________________________________________________________________________________________________________________________________________________________________________________________"
    );
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: company?.id,
      user_id: data.user_id,
      skip: 0,
      limit: 15,
      assignees: JSON.stringify(
        _selectedUser == undefined ? selectedUser : _selectedUser
      ),
      template: JSON.stringify(
        _selectedTemplates == undefined ? selectedTemplates : _selectedTemplates
      ),
      sites: JSON.stringify(
        _selectedSites == undefined ? selectedSites : _selectedSites
      ),
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset
        ? undefined
        : moment(datesFilters.endDate)
            .add(1, "d")
            .format("YYYY-MM-DD"),
    };

    console.log(":::::::::::::::::::::::::::::::::::::::::::", params);

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    console.log(query);
    fetch(GlobalApi + "/Inspection/get_all_archived_inspections_share_page?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("{{{{{{{{{{{{{{{{{{{{{{{{{", response);
        if (response.status === "Success") {
          setTotalRecords(response.total_records);
          if (response.data) {
            setRows([...response.data]);
            setInspectionLoader(false);

            // setInspection(response.data);
            console.log(
              "__________________________________________________________________________________________________________________________________________________________________________________________________________"
            );
            console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            getInspection();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  const getMoreInspection = (reset = false) => {
    console.log(
      "__________________________________________________________________________________________________________________________________________________________________________________________________________"
    );
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let _rows = [...rows];
    let token = data.token;
    let params = {
      company_id: company?.id,
      user_id: data.user_id,
      skip: rows.length,
      limit: 15,
      assignees: JSON.stringify(selectedUser),
      template: JSON.stringify(selectedTemplates),
      sites: JSON.stringify(selectedSites),
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset
        ? undefined
        : moment(datesFilters.endDate)
            .add(1, "d")
            .format("YYYY-MM-DD"),
    };
    console.log("KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK", params);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    console.log(query);
    fetch(GlobalApi + "/Inspection/get_all_archived_inspections_share_page?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("{{{{{{{{{{{{{{{{{{{{{{{{{", response);
        if (response.status === "Success") {
          setTotalRecords(response.total_records);

          if (response.data) {
            setRows([...rows, ...response.data]);
            console.log(
              "__________________________________________________________________________________________________________________________________________________________________________________________________________"
            );
            console.log(response, "{}{}{}{}");
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            getInspection();
          }
        }
      })
      .catch((error) => console.log(error.message));
    console.log("op");
  };

  function getFileSize() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data?.user_id,
      organization_id: data?.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/ConfigFileSize/get_all_file_sizes_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response.data);
          dispatch({ type: "SET_FILE_SIZE", payload: response.data });
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
        }
      })
      .catch((error) => console.log(error.message));
  }

  const deleteInspection = (currentEditInspection) => {
    console.log("currentEditInspection", currentEditInspection);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    swal({
      title: t("Are you sure?"),
      text: t("You will not be able to restore this Inspection!"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        try {
          fetch(
            GlobalApi +
              "/company/delete_inspection_cmp/" +
              currentEditInspection,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              },
            }
          )
            .then((responseJson) => responseJson.json())
            .then(async (response) => {
             
             if(response.msg =='success'){
               handleClose2();
              console.log("DELETE RESPONSE", response);
              swal(
                t("Success"),
                t("Inspection Has Been Deleted"),
                "success"
              );
              getInspection(true);
              getFileSize();
             }
            })
            .catch((error) => console.log(error.message));
        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("Canceled");
      }
    });
  };
  const restoreInspection = (currentEditInspection) => {
    console.log("currentEditInspection", currentEditInspection);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    swal({
      title: t("Are you sure?"),
      text: t("you want to restore this Inspection!"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        try {
          fetch(
            GlobalApi +
              "/Inspection/restore_inspection/" +
              currentEditInspection,
            {
              method: "GET",
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              },
            }
          )
            .then((responseJson) => responseJson.json())
            .then(async (response) => {
              if(response.msg == 'success'){
                handleClose2();

                swal(
                  t("Success"),
                  t("Inspection Has Been Restored"),
                  "success"
                );
                console.log("DELETE RESPONSE", response);
                getInspection(true);
                getFileSize();
              }
             
            })
            .catch((error) => console.log(error.message));
        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("Canceled");
      }
    });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    console.log(rows.length, newPage * 10);
    if (rows.length >= newPage * 10) {
      getInspection(rows.length + 1, newPage + rowsPerPage);
    }
    setPage(newPage);
    console.log(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value, 10);
    setRowsPerPage(parseInt(event.target.value, 10));
    setRows([]);
    getInspection(1, event.target.value, false);
    setPage(0);
  };

  // const handleChangeDense = (event) => {
  //   setDense(event.target.checked);
  // };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows?.length - page * rowsPerPage);

  const ModalOpen = (row) => {
    setAnchorEl(null);
    setIsModalOpen(row);
  };

  // if (rows == null) {
  //   return <Spinner />;
  // } else {
  return (
    <>
      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        style={{
          padding: "5px 20px 0px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            overflow: "hidden",
            width: "100%",
          }}
        >
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            spacing={2}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "white",
              padding: "0px",
              borderRadius: "5px",
            }}
          >
            <Grid item xs={12} lg={4}  style={{alignItems:'center', display:'flex'}}>
            
            <Grid container  style={{alignItems:'center', display:'flex'}}>
              <TextField
                size="small"
                autoComplete="off"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={search} width={12} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title={t("Filter Options")}>
                        <img
                          src={filter}
                          width={20}
                          style={{ cursor: "pointer" }}
                          onClick={handleClick3}
                        />
                      </Tooltip>
                    </InputAdornment>
                  ),
                  classes: { input: classes.resize },
                }}
                placeholder={t("Search in existing Inspections")}
                fullWidth
                onChange={(e) => setSearchText(e.target.value)}
                variant="outlined"
                style={{
                  width: "75%",
                  backgroundColor: Colors.globalColor5,
                  marginTop: "5px",
                }}
              />
              <div  style={{alignItems:'center', display:'flex', height:'100%'}}>
              <Tooltip title={t("Help")}>
               
                <a href="https://www.uraudits.com/knowledge-center/inspection/" target="blank" style={{color:Colors.globalColor8}}>
                <img src={language =="ar"? helpAr: help} height={25} style={{marginLeft:'5px', marginTop:"10px"}}/>
                  </a>
               
              </Tooltip>
              </div>
              </Grid>
              {/* =================================popover 1=========================== */}

              <Popover
                open={open}
                anchorEl={filterMenu1}
                onClose={handleClose3}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <div
                  style={{
                    width: "150px",
                    minHeight: "100px",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    padding: "0px",
                  }}
                >
                  <List component="nav" aria-label="secondary mailbox folders">
                    <ListItem
                      button
                      style={{ paddingTop: "2px", paddingBottom: "2px" }}
                      onClick={(e) => handleClick4(e)}
                    >
                      <ListItemText primary={t("Assignees")} />
                    </ListItem>
                    <ListItem
                      button
                      style={{ paddingTop: "2px", paddingBottom: "2px" }}
                      onClick={(e) => handleClick5(e)}
                    >
                      <ListItemText primary={t("Templates")} />
                    </ListItem>
                    <ListItem
                      button
                      style={{ paddingTop: "2px", paddingBottom: "2px" }}
                      onClick={(e) => handleClick6(e)}
                    >
                      <ListItemText primary={t("Sites")} />
                    </ListItem>
                    <ListItem
                      button
                      style={{ paddingTop: "2px", paddingBottom: "2px" }}
                      onClick={(e) => handleClick7(e)}
                    >
                      <ListItemText primary={t("Dates")} />
                    </ListItem>
                  </List>
                </div>
              </Popover>

              {/* =================================popover 2=========================== */}
              <Popover
                open={open2}
                anchorEl={filterMenu2}
                onClose={handleClose4}
                anchorOrigin={{ vertical: "center", horizontal: "right" }}
                transformOrigin={{ vertical: "center", horizontal: "left" }}
                style={{ margin: "20px" }}
              >
                <div
                  style={{
                    width: "300px",
                    minHeight: "100px",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <TextField
                    size="small"
                    autoComplete="off"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={search} width={12} />
                        </InputAdornment>
                      ),
                      classes: { input: classes.resize },
                    }}
                    placeholder={t("Search")}
                    fullWidth
                    variant="outlined"
                    style={{ backgroundColor: Colors.globalColor5 }}
                    value={userFilter}
                    onChange={(e) => setUserFilter(e.target.value)}
                  />

                  <br />
                  <p
                    className="label2"
                    style={{
                      marginTop: "20px",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {t("Assignees")}
                  </p>
                  <div
                    className="scrollbarShow2"
                    style={{ maxHeight: "100px", overflowY: "scroll" }}
                  >
                    {Assignees.filter(
                      (word) =>
                        word.first_name
                          .toLowerCase()
                          .includes(userFilter.toLowerCase()) ||
                        word.last_name
                          .toLowerCase()
                          .includes(userFilter.toLowerCase()) ||
                        (word.first_name + " " + word.last_name)
                          .toLowerCase()
                          .includes(userFilter.toLowerCase())
                    ).map((item, index) => {
                      return (
                        <span style={{ display: "block" }}>
                          <Checkbox
                            className="filterCheckbox"
                            style={{ color: Colors.globalColor8 }}
                            onChange={(e) =>
                              selectUsers(e.target.checked, item)
                            }
                            defaultChecked={selectedUser.indexOf(item.id) > -1}
                          />
                          <p
                            className="label2"
                            style={{
                              display: "inline",
                              marginTop: "0px",
                              fontSize: 12,
                              textTransform: "capitalize",
                              fontWeight: "normal",
                            }}
                          >
                            {item.first_name}
                          </p>
                          &nbsp;
                          <p
                            className="label2"
                            style={{
                              display: "inline",
                              marginTop: "0px",
                              fontSize: 12,
                              textTransform: "capitalize",
                              fontWeight: "normal",
                            }}
                          >
                            {item.last_name}
                          </p>
                        </span>
                      );
                    })}
                  </div>

                  <hr
                    style={{
                      borderTop: "1px solid #dadada",
                      borderBottom: "none",
                      marginTop: 10,
                      width: "100%",
                      marginBottom: 20,
                    }}
                  />
                  <Button className="ctBtn" onClick={() => handleDone("Users")}>
                    {t("Done")}
                  </Button>
                </div>
              </Popover>

              {/* =================================popover 3=========================== */}
              <Popover
                open={open3}
                anchorEl={filterMenu3}
                onClose={handleClose5}
                anchorOrigin={{ vertical: "center", horizontal: "right" }}
                transformOrigin={{ vertical: "center", horizontal: "left" }}
                style={{ margin: "20px" }}
              >
                <div
                  style={{
                    width: "300px",
                    minHeight: "100px",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <TextField
                    size="small"
                    autoComplete="off"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={search} width={12} />
                        </InputAdornment>
                      ),
                      classes: { input: classes.resize },
                    }}
                    placeholder="Search"
                    fullWidth
                    variant="outlined"
                    style={{ backgroundColor: Colors.globalColor5 }}
                    value={templateFilter}
                    onChange={(e) => setTemplateFilter(e.target.value)}
                  />

                  <br />
                  <p
                    className="label2"
                    style={{
                      marginTop: "20px",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {t("Templates")}
                  </p>
                  <div
                    className="scrollbarShow2"
                    style={{ maxHeight: "100px", overflowY: "scroll" }}
                  >
                    {templates
                      .filter((word) =>
                        word.name
                          .toLowerCase()
                          .includes(templateFilter.toLowerCase())
                      )
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map((item, index) => {
                        if (item.name) {
                          return (
                            <span style={{ display: "block" }}>
                              <Checkbox
                                className="filterCheckbox"
                                style={{ color: Colors.globalColor8 }}
                                onChange={(e) =>
                                  selectTemplate(e.target.checked, item)
                                }
                                defaultChecked={
                                  selectedTemplates.indexOf(item.id) > -1
                                }
                              />
                              <p
                                className="label2"
                                style={{
                                  display: "inline",
                                  marginTop: "0px",
                                  fontSize: 12,
                                  textTransform: "capitalize",
                                  fontWeight: "normal",
                                }}
                              >
                                {item.name}
                              </p>
                            </span>
                          );
                        }
                      })}
                  </div>

                  <hr
                    style={{
                      borderTop: "1px solid #dadada",
                      borderBottom: "none",
                      marginTop: 10,
                      width: "100%",
                      marginBottom: 20,
                    }}
                  />
                  <Button
                    className="ctBtn"
                    onClick={() => handleDone("Templates")}
                  >
                    {/* //  onClick={() => onSelectUser()} */}
                    {t("Done")}
                  </Button>
                </div>
              </Popover>

              {/* =================================popover 4=========================== */}
              <Popover
                open={open4}
                anchorEl={filterMenu4}
                onClose={handleClose6}
                anchorOrigin={{ vertical: "center", horizontal: "right" }}
                transformOrigin={{ vertical: "center", horizontal: "left" }}
                style={{ margin: "20px" }}
              >
                <div
                  style={{
                    width: "300px",
                    minHeight: "100px",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <TextField
                    size="small"
                    autoComplete="off"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={search} width={12} />
                        </InputAdornment>
                      ),
                      classes: { input: classes.resize },
                    }}
                    placeholder="Search"
                    fullWidth
                    variant="outlined"
                    style={{ backgroundColor: Colors.globalColor5 }}
                    value={siteFilter}
                    onChange={(e) => setSiteFilter(e.target.value)}
                  />

                  <br />
                  <p
                    className="label2"
                    style={{
                      marginTop: "20px",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {t("Sites")}
                  </p>
                  <div
                    className="scrollbarShow2"
                    style={{ maxHeight: "100px", overflowY: "scroll" }}
                  >
                    {sites
                      .filter((word) =>
                        word.Site.toLowerCase().includes(
                          siteFilter.toLowerCase()
                        )
                      )
                      .sort((a, b) => a.Site.localeCompare(b.Site))
                      .map((item, index) => {
                        return (
                          <span style={{ display: "block" }}>
                            <Checkbox
                              className="filterCheckbox"
                              style={{ color: Colors.globalColor8 }}
                              onChange={(e) =>
                                selectSite(e.target.checked, item)
                              }
                              defaultChecked={
                                selectedSites.indexOf(item.site_id) > -1
                              }
                            />
                            <p
                              className="label2"
                              style={{
                                display: "inline",
                                marginTop: "0px",
                                fontSize: 12,
                                textTransform: "capitalize",
                                fontWeight: "normal",
                              }}
                            >
                              {item.Site}
                            </p>
                          </span>
                        );
                      })}
                  </div>

                  <hr
                    style={{
                      borderTop: "1px solid #dadada",
                      borderBottom: "none",
                      marginTop: 10,
                      width: "100%",
                      marginBottom: 20,
                    }}
                  />
                  <Button className="ctBtn" onClick={() => handleDone("Sites")}>
                    {/* //  onClick={() => onSelectUser()} */}
                    {t("Done")}
                  </Button>
                </div>
              </Popover>

              {/* =================================popover 5=========================== */}
              <Popover
                open={open5}
                anchorEl={filterMenu5}
                onClose={handleClose7}
                anchorOrigin={{ vertical: "center", horizontal: "right" }}
                transformOrigin={{ vertical: "center", horizontal: "left" }}
                style={{ margin: "20px" }}
              >
                <div
                  style={{
                    width: "300px",
                    minHeight: "100px",
                    backgroundColor: "white",
                    borderRadius: "5px",
                    padding: "10px",
                  }}
                >
                  <p
                    className="label2"
                    style={{
                      marginTop: "20px",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {t("Select Date Range")}
                  </p>
                  <span style={{ display: "block" }}>
                    <Checkbox
                      className="filterCheckbox"
                      style={{ color: Colors.globalColor8 }}
                      checked={datesFilters.today}
                      onChange={() => handleToday()}
                    />
                    <p
                      className="label2"
                      style={{
                        display: "inline",
                        marginTop: "0px",
                        fontSize: 12,
                        textTransform: "capitalize",
                        fontWeight: "normal",
                      }}
                    >
                      {t("Today")}
                    </p>
                  </span>
                  <span style={{ display: "block" }}>
                    <Checkbox
                      className="filterCheckbox"
                      style={{ color: Colors.globalColor8 }}
                      checked={datesFilters.yesterday}
                      onChange={() => handleYesterday()}
                    />
                    <p
                      className="label2"
                      style={{
                        display: "inline",
                        marginTop: "0px",
                        fontSize: 12,
                        textTransform: "capitalize",
                        fontWeight: "normal",
                      }}
                    >
                      {t("Yesterday")}
                    </p>
                  </span>
                  <span style={{ display: "block" }}>
                    <Checkbox
                      className="filterCheckbox"
                      style={{ color: Colors.globalColor8 }}
                      checked={datesFilters.last7}
                      onChange={() => handle7Days()}
                    />
                    <p
                      className="label2"
                      style={{
                        display: "inline",
                        marginTop: "0px",
                        fontSize: 12,
                        textTransform: "capitalize",
                        fontWeight: "normal",
                      }}
                    >
                      {t("Last 7 Days")}
                    </p>
                  </span>
                  {/* <span style={{ display: "block" }}>
                    <Checkbox className="filterCheckbox" style={{ color: Colors.globalColor8 }} checked={datesFilters.last15} onChange={()=>handle15Days()} />
                    <p className="label2" style={{ display: "inline", marginTop: "0px", fontSize: 12, textTransform: "capitalize", fontWeight: "normal" }}>
                      Last 15 Days
                    </p>
                  </span> */}
                  <span style={{ display: "block" }}>
                    <Checkbox
                      className="filterCheckbox"
                      style={{ color: Colors.globalColor8 }}
                      checked={datesFilters.lastMonth}
                      onChange={() => handle1Month()}
                    />
                    <p
                      className="label2"
                      style={{
                        display: "inline",
                        marginTop: "0px",
                        fontSize: 12,
                        textTransform: "capitalize",
                        fontWeight: "normal",
                      }}
                    >
                      {t("Last Month")}
                    </p>
                  </span>
                  <p
                    className="label2"
                    style={{
                      marginTop: "20px",
                      fontSize: 14,
                      fontWeight: "bold",
                    }}
                  >
                    {t("Custom Range")}
                  </p>

                  {/* <KeyboardDatePicker className="filterDatePicker" disableToolbar label="From Date"  format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.startDate} onChange={handleStartDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                  {/* <hr style={{ borderTop: "1px solid #dadada", borderBottom: "none", marginTop: 0, width: "100%", marginBottom: 10 }} /> */}
                  <form className={classes.container} noValidate>
                    <TextField
                      variant="outlined"
                      className="filterDatePicker"
                      label={t("From Date")}
                      type="date"
                      size="small"
                      fullwidth
                      value={datesFilters.startDate}
                      onChange={handleStartDate}
                      style={{ width: "100%", marginTop: "10px" }}
                      InputLabelProps={{ shrink: true }}
                    />
                    <TextField
                      variant="outlined"
                      className="filterDatePicker"
                      label={t("To Date")}
                      type="date"
                      size="small"
                      fullwidth
                      value={datesFilters.endDate}
                      onChange={handleEndDate}
                      style={{ width: "100%", marginTop: "10px" }}
                      InputLabelProps={{ shrink: true }}
                    />
                    {/* <KeyboardDatePicker className="filterDatePicker" style={{ marginTop: "10px", marginBottom: "10px" }} disableToolbar label="To Date" variant="outlined" format="MM/dd/yyyy" margin="normal" id="date-picker-inline" value={datesFilters.endDate} onChange={handleEndDate} KeyboardButtonProps={{ "aria-label": "change date" }} /> */}
                  </form>
                  <hr
                    style={{
                      borderTop: "1px solid #dadada",
                      borderBottom: "none",
                      marginTop: 10,
                      width: "100%",
                      marginBottom: 20,
                    }}
                  />
                  <Button className="ctBtn" onClick={() => handleDone2()}>
                    {/* onClick={() => onSelectAccess()} */}
                    Done
                  </Button>
                </div>
              </Popover>
            </Grid>

            {(filterApplied ||
              selectedUser.length > 0 ||
              selectedTemplates.length > 0 ||
              selectedSites.length > 0) && (
              <Grid item xs={12} lg={6}>
                <div
                  className="scrollHidden2"
                  style={{
                    overflowX: "scroll",
                    whiteSpace: "nowrap",
                    display: "flex",
                    width: "100%",
                    paddingBottom: "5px",
                  }}
                >
                  {selectedUser.length > 0 && appliedFilters.Users && (
                    <div
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #043077",
                          color: "#043077",
                          overflow: "hidden",
                          height: "100%",
                          borderRadius: "5px",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "inline",
                            borderRight: "1px solid #043077",
                            padding: "5px",
                            backgroundColor: Colors.globalColor9,
                          }}
                        >
                          {
                            Assignees.filter((v) => v.id == selectedUser[0])[0]
                              .first_name
                          }{" "}
                          {selectedUser.length > 1 && (
                            <> +{selectedUser.length - 1} </>
                          )}
                        </div>{" "}
                        <div
                          onClick={() => clearUsersFilter()}
                          style={{
                            backgroundColor: Colors.globalColor9,
                            display: "inline",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                        >
                          x
                        </div>
                      </div>
                    </div>
                  )}
                  &nbsp;
                  {selectedTemplates.length > 0 && appliedFilters.Templates && (
                    <div
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #043077",
                          color: "#043077",
                          overflow: "hidden",
                          height: "100%",
                          borderRadius: "5px",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "inline",
                            borderRight: "1px solid #043077",
                            padding: "5px",
                            backgroundColor: Colors.globalColor9,
                          }}
                        >
                          {templates
                            .filter((v) => v.id == selectedTemplates[0])[0]
                            .name.slice(0, 20) + "..."}{" "}
                          {selectedTemplates.length > 1 && (
                            <> +{selectedTemplates.length - 1} </>
                          )}
                        </div>{" "}
                        <div
                          onClick={() => clearTemplatesFilter()}
                          style={{
                            backgroundColor: Colors.globalColor9,
                            display: "inline",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                        >
                          x
                        </div>
                      </div>
                    </div>
                  )}
                  &nbsp;
                  {selectedSites.length > 0 && appliedFilters.Sites && (
                    <div
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #043077",
                          color: "#043077",
                          overflow: "hidden",
                          height: "100%",
                          borderRadius: "5px",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "inline",
                            borderRight: "1px solid #043077",
                            padding: "5px",
                            backgroundColor: Colors.globalColor9,
                          }}
                        >
                          {
                            sites.filter(
                              (v) => v.site_id == selectedSites[0]
                            )[0].Site
                          }{" "}
                          {selectedSites.length > 1 && (
                            <> +{selectedSites.length - 1} </>
                          )}
                        </div>{" "}
                        <div
                          onClick={() => clearSitesFilter()}
                          style={{
                            backgroundColor: Colors.globalColor9,
                            display: "inline",
                            padding: "5px",
                            cursor: "pointer",
                          }}
                        >
                          x
                        </div>
                      </div>
                    </div>
                  )}
                  &nbsp;
                  {filterApplied && (
                    <div
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                    >
                      <div
                        style={{
                          backgroundColor: Colors.globalColor9,
                          border: "1px solid #043077",
                          color: "#043077",
                          height: "100%",
                          borderRadius: "5px",
                          display: "inline-flex",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "inline",
                            borderRight: "1px solid #043077",
                            padding: "5px",
                          }}
                        >
                          {datesFilters.today && "Today"}
                          {datesFilters.yesterday && "Yesterday"}
                          {!datesFilters.today &&
                            !datesFilters.yesterday &&
                            `From : ${moment(datesFilters.startDate).format(
                              "DD-MM-YY"
                            )} - To: ${moment(datesFilters.endDate).format(
                              "DD-MM-YY"
                            )}`}
                        </div>{" "}
                        <div
                          onClick={() => clearDatesFilter()}
                          style={{
                            display: "inline",
                            padding: "0px 5px",
                            cursor: "pointer",
                          }}
                        >
                          x
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
            )}

            <Grid
              item
              xs={12}
              lg={2}
              style={{
                textAlign: window.innerWidth > 700 ? (language =="ar" ?"left": "right") : "center",
              }}
            >
              {searchText == "" && (
              <p
              className="label2"
              style={{
                textAlign: window.innerWidth > 700 ? (language =="ar" ?"left": "right") : "center",
                display: "inline",
                marginTop: 8,
                fontSize: 12,
                color: "grey",
                textTransform: "capitalized",
              }}
            >
              {t("showing records")} {rows.length} {t("of")} {totalRecords}
            </p>
              )}
            </Grid>
          </Grid>
        </div>
      </Grid>
      <div style={{ width: "100%", padding: "5px" }}>
        {inspectionLoader && (
          <div style={{ width: "100%", textAlign: "center", padding: 20 }}>
            <Spinner />
          </div>
        )}
        {!inspectionLoader && (
          <div
            className="scrollbarShow2"
            style={{
              height: "60vh",
              overflowY: "scroll",
              overflowX: "hidden",
              width: "100%",
            }}
          >
            {!inspectionLoader && (
              <>
                {rows.length == 0 && (
                  <div
                    style={{
                      padding: "20px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <NoRecords />
                  </div>
                )}
                {rows.length !== 0 && (
                  <Grid
                    container
                    justifyContent="center"
                    spacing={1}
                    style={{
                      padding: window.innerWidth > 500 ? "10px 20px  20px" : "0px",
                      maxHeight: "300px",
                    }}
                  >
                    <div style={{ width: "100%" }}>
                      {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                      {window.innerWidth > 500 && (
                        <TableContainer
                          className={classes.container}
                          id="InspectionScroll"
                          onScroll={(e) => handleScroll(e)}
                        >
                          <Table
                            stickyHeader
                            aria-label="sticky table"
                            style={{
                              width: "100%",
                              borderLeft: "1px solid #dadada",
                              borderRight: "1px solid #dadada",
                            }}
                          >
                            <EnhancedTableHead
                              classes={classes}
                              numSelected={selected.length}
                              order={order}
                              orderBy={orderBy}
                              onRequestSort={handleRequestSort}
                              rowCount={rows.length}
                            />
                            <TableBody>
                              {rows.length !== 0 &&
                                rows
                                  .filter(
                                    (v) =>
                                      v?.schedule_title
                                        ?.toLowerCase()
                                        .includes(searchText?.toLowerCase()) ||
                                      v?.template_title
                                        ?.toLowerCase()
                                        .includes(searchText?.toLowerCase()) ||
                                      v?.site_title
                                        ?.toLowerCase()
                                        .includes(searchText?.toLowerCase())
                                  )
                                  .map((row, index) => {
                                    console.log("ROW>>>>>>>>>>>>", row);
                                    const isItemSelected = isSelected(row.name);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    // let score_nag = row.InspectionAnswers.filter((v) => {
                                    //   // console.log(answers[v.id]?.value, answers[v.id])
                                    //   if (
                                    //     v.parent_id === null &&
                                    //     (v.value === "" ||
                                    //       v.value === "[]" ||
                                    //       v.value === undefined ||
                                    //       v.value === null)
                                    //   ) {
                                    //     // console.log("o");
                                    //     return v;
                                    //   }
                                    // });

                                    // let score = (
                                    //   ((row.InspectionAnswers.filter(
                                    //     (v) => v.parent_id === null
                                    //   ).length -
                                    //     score_nag.length) /
                                    //     row.InspectionAnswers.filter(
                                    //       (v) => v.parent_id === null
                                    //     ).length) *
                                    //   100
                                    // ).toFixed();

                                    return (
                                      <TableRow
                                        hover
                                        onClick={(event) =>
                                          handleClick(event, row.name)
                                        }
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.name}
                                        className="testingtable"
                                      >
                                        <TableCell
                                          component="th"
                                          id={labelId}
                                          scope="row"
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            textAlign:language=="ar" ? "right" : "left",
                                          }}
                                        >
                                          {
                                            <Tooltip
                                              title={
                                                row?.schedule_title
                                                  ? row?.schedule_title
                                                  : ""
                                              }
                                            >
                                              <p style={{ margin: 0 }}>
                                                {row?.schedule_title.slice(
                                                  0,
                                                  30
                                                ) +
                                                  (row?.schedule_title.length >
                                                  30
                                                    ? "..."
                                                    : "")}
                                              </p>
                                            </Tooltip>
                                          }
                                        </TableCell>
                                        <TableCell
                                  
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            borderLeft: "1px solid #dadada",
                                            borderRight: "1px solid #dadada",
                                              textAlign:language=="ar" ? "right" : "left",
                                          }}
                                        >
                                          {
                                            <Tooltip
                                              title={
                                                row?.template_title
                                                  ? row?.template_title
                                                  : ""
                                              }
                                            >
                                              <p style={{ margin: 0 }}>
                                                {row?.template_title.slice(
                                                  0,
                                                  30
                                                ) +
                                                  (row.template_title?.length >
                                                  30
                                                    ? "..."
                                                    : "")}
                                              </p>
                                            </Tooltip>
                                          }
                                        </TableCell>
                                        {/* <TableCell align="right">none</TableCell> */}
                                        <TableCell
                                        
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            textAlign:language=="ar" ? "right" : "left",

                                          }}
                                        >
                                          {row?.site_title}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            borderLeft: "1px solid #dadada",
                                            borderRight: "1px solid #dadada",
                                            textAlign:language=="ar" ? "right" : "left",
                                          }}
                                        >
                                          {moment(row.createdAt).format(
                                            "MM/DD/YY"
                                          )}
                                        </TableCell>
                                        <TableCell
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            textAlign:language=="ar" ? "right" : "left",
                                          }}
                                        >
                                          {row.score ? row.score : 0}%
                                        </TableCell>
                                        <TableCell
                                          
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            borderLeft: "1px solid #dadada",
                                            borderRight: "1px solid #dadada",
                                            textAlign:language=="ar" ? "right" : "left",
                                          }}
                                        >
                                          {row.isCompleted == true
                                            ? "completed"
                                            : "Incomplete"}
                                        </TableCell>
                                        <TableCell
                                        
                                          style={{
                                            paddingTop: "0px",
                                            paddingBottom: "0px",
                                            textAlign:language=="ar" ? "right" : "left",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "row",
                                            }}
                                          >
                                            {row?.assignees_user?.map(
                                              (v, i) => {
                                                if (i <= 2) {
                                                  return (
                                                    <Tooltip
                                                      title={`${
                                                        v?.first_name
                                                      } ${v?.last_name}`}
                                                      aria-label=""
                                                    >
                                                      {v?.avatar !== null ? (
                                                        <div
                                                          style={{
                                                            width: 30,
                                                            height: 30,
                                                            borderRadius:
                                                              "50px",
                                                            color: "#043077",
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            margin: 1,
                                                            alignItems:
                                                              "center",
                                                            backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                              v?.avatar
                                                            })`,
                                                            backgroundSize:
                                                              "cover",
                                                          }}
                                                        />
                                                      ) : (
                                                        <div
                                                          style={{
                                                            width: 30,
                                                            height: 30,
                                                            borderRadius:
                                                              "50px",
                                                            border:
                                                              "1px solid #043077",
                                                            color: "#043077",
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            margin: 1,
                                                            alignItems:
                                                              "center",
                                                          }}
                                                        >
                                                          <p
                                                            style={{
                                                              margin: 0,
                                                              fontWeight:
                                                                "bold",
                                                              fontSize: "10px",
                                                            }}
                                                          >
                                                            {v?.first_name
                                                              .substring(0, 1)
                                                              .toUpperCase()
                                                              .concat(
                                                                v?.last_name
                                                                  .substring(
                                                                    0,
                                                                    1
                                                                  )
                                                                  .toUpperCase()
                                                              )}
                                                          </p>
                                                        </div>
                                                      )}
                                                    </Tooltip>
                                                  );
                                                } else {
                                                  return (
                                                    <div
                                                      style={{
                                                        width: 30,
                                                        height: 30,
                                                        borderRadius: "50px",
                                                        border:
                                                          "1px solid #043077",
                                                        color: "#043077",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        margin: 1,
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <p>
                                                        +
                                                        {row?.assignees_user
                                                          .length - 3}
                                                      </p>
                                                    </div>
                                                  );
                                                }
                                              }
                                            )}
                                          </div>
                                        </TableCell>
                                        <TableCell
                                         
                                          style={{
                                            paddingTop: "5px",
                                            paddingBottom: "5px",
                                            borderLeft: language=="ar" ? "none" : "1px solid #dadada",
                                            borderRight:  language=="ar" ? "1px solid #dadada" : "none",
                                            textAlign:language=="ar" ? "right" : "left",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              padding: 0,
                                            }}
                                          >
                                            <>
                                              <img
                                                src={dots}
                                                onClick={(e) => {
                                                  setCurrentEditInspection(
                                                    row.id
                                                  );
                                                  setCurrentEditRow(row);
                                                  handleClick2(e);
                                                }}
                                                width={30}
                                                alt="open modal"
                                                style={{
                                                  marginTop: "0px",
                                                  cursor: "pointer",
                                                }}
                                                onMouseOver={(e) =>
                                                  (e.currentTarget.src = dotsH)
                                                }
                                                onMouseOut={(e) =>
                                                  (e.currentTarget.src = dots)
                                                }
                                              />
                                              <Menu
                                                id="simple-menu"
                                                anchorEl={anchorEl}
                                                className="extraMenuBox"
                                                keepMounted
                                                open={Boolean(anchorEl)}
                                                onClose={handleClose2}
                                              >

{currentEditRow?.created_by ==
                                            currentUser?.user_id ||
                                          currentEditRow?.assignees_ids_parsed?.filter(
                                            (v) => v == currentUser.user_id
                                          ).length > 0 ?
                                                <MenuItem
                                                  onClick={() => restoreInspection(currentEditInspection)
                                                  }
                                                >
                                                  <img
                                                    src={restore}
                                                    alt="file"
                                                    width={20}
                                                  />
                                                  &nbsp; Restore Inspection
                                                </MenuItem>: <MenuItem
                                                 disabled
                                                >
                                                  <img
                                                    src={restoreG}
                                                    alt="file"
                                                    width={20}
                                                  />
                                                  &nbsp; Restore Inspection
                                                </MenuItem>}
                                               
                                                {/* <MenuItem
                                                  onClick={() =>
                                                    deleteInspection(
                                                      currentEditInspection
                                                    )
                                                  }
                                                >
                                                  <img
                                                    src={deleteIcon}
                                                    alt="file"
                                                    width={20}
                                                  />
                                                  &nbsp; Delete Permanently
                                                </MenuItem>
                                               */}
                                              </Menu>
                                              {/* <img src={dots} alt="..."  style={{ cursor: "pointer" }} /> */}
                                            </>
                                          </div>
                                        </TableCell>

                                        {/* <div className="hover-div pointer-cursor">

                             history.push("inspection-edit/" + row.id + "/edit")


                              <div
                                className="reply text-center "
                                style={{ visibility: "hidden" }}
                              >
                                <ReplayIcon />
                                <br />
                                View History
                              </div>
                              <div
                                className="text-center"
                                onClick={() =>
                                  history.push("/inspection-print/" + row.id)
                                }
                              >
                                <BookIcon />
                                <br />
                                View Report
                              </div>
                              <div
                                className="text-center"
                                onClick={() =>
                                  history.push(
                                    "inspection-edit/" + row.id + "/edit"
                                  )
                                }
                              >
                                <EditIcon />
                                <br />
                                Edit
                              </div>
                              <div
                                className="text-center"
                                onClick={() => ModalOpen(row)}
                              >
                                <MoreHorizIcon />
                                <br />
                                More Option
                              </div>
                            </div> */}
                                      </TableRow>
                                    );
                                  })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}

                      {window.innerWidth <= 500 && (
                        <div
                          className={classes.container}
                          style={{
                            overflowY: "scroll",
                            width: "100%",
                            padding: "5px",
                          }}
                          id="InspectionScroll"
                          onScroll={(e) => handleScroll(e)}
                        >
                          {rows.length !== 0 &&
                            rows
                              .filter(
                                (v) =>
                                  v?.schedule_title
                                    ?.toLowerCase()
                                    .includes(searchText?.toLowerCase()) ||
                                  v?.template_title
                                    ?.toLowerCase()
                                    .includes(searchText?.toLowerCase()) ||
                                  v?.site_title
                                    ?.toLowerCase()
                                    .includes(searchText?.toLowerCase())
                              )
                              .map((row, index) => {
                                return (
                                  <div
                                    className="hover shadow"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      border: "1px solid #dadada",
                                      padding: "10px",
                                      margin: "5px",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      textAlign: "left",
                                      height: "220px",
                                      borderRadius: "5px",
                                      backgroundColor: "white",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        height: "100%",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div>
                                        <p
                                          style={{
                                            color: Colors.globalColor8,
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                            textAlign: "left",
                                            marginBottom: "0px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          Name
                                        </p>

                                        <p
                                          style={{
                                            fontSize: "12px",
                                            textAlign: "left",
                                            marginBottom: "0px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          {row?.schedule_title.slice(0, 30) +
                                            (row?.schedule_title.length > 30
                                              ? "..."
                                              : "")}
                                        </p>
                                      </div>
                                      <div>
                                        <p
                                          style={{
                                            color: Colors.globalColor8,
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                            textAlign: "left",
                                            marginBottom: "0px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          Template
                                        </p>
                                        <p
                                          style={{
                                            fontSize: "12px",
                                            textAlign: "left",
                                            marginBottom: "0px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          {row?.template_title.slice(0, 30) +
                                            (row.template_title?.length > 30
                                              ? "..."
                                              : "")}
                                        </p>
                                      </div>
                                      <div>
                                        <p
                                          style={{
                                            color: Colors.globalColor8,
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                            textAlign: "left",
                                            marginBottom: "0px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          Site{" "}
                                        </p>
                                        <p
                                          style={{
                                            fontSize: "12px",
                                            textAlign: "left",
                                            marginBottom: "0px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          {row?.site_title}
                                        </p>
                                      </div>
                                      <div>
                                        <p
                                          style={{
                                            color: Colors.globalColor8,
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                            textAlign: "left",
                                            marginBottom: "0px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          {t("Assigned To")}
                                        </p>
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        >
                                          {row?.assignees_user?.map((v, i) => {
                                            if (i <= 2) {
                                              return (
                                                <Tooltip
                                                  title={`${v?.first_name} ${
                                                    v?.last_name
                                                  }`}
                                                  aria-label=""
                                                >
                                                  {v?.avatar !== null ? (
                                                    <div
                                                      style={{
                                                        width: 30,
                                                        height: 30,
                                                        borderRadius: "50px",
                                                        color: "#043077",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        margin: 1,
                                                        alignItems: "center",
                                                        backgroundImage: `url(https://server.uraudits.com/view?Key=${
                                                          v?.avatar
                                                        })`,
                                                        backgroundSize: "cover",
                                                      }}
                                                    />
                                                  ) : (
                                                    <div
                                                      style={{
                                                        width: 30,
                                                        height: 30,
                                                        borderRadius: "50px",
                                                        border:
                                                          "1px solid #043077",
                                                        color: "#043077",
                                                        display: "flex",
                                                        justifyContent:
                                                          "center",
                                                        margin: 1,
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <p
                                                        style={{
                                                          margin: 0,
                                                          fontWeight: "bold",
                                                          fontSize: "10px",
                                                        }}
                                                      >
                                                        {v?.first_name
                                                          .substring(0, 1)
                                                          .toUpperCase()
                                                          .concat(
                                                            v?.last_name
                                                              .substring(0, 1)
                                                              .toUpperCase()
                                                          )}
                                                      </p>
                                                    </div>
                                                  )}
                                                </Tooltip>
                                              );
                                            } else {
                                              return (
                                                <div
                                                  style={{
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: "50px",
                                                    border: "1px solid #043077",
                                                    color: "#043077",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    margin: 1,
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <p>
                                                    +
                                                    {row?.assignees_user
                                                      .length - 3}
                                                  </p>
                                                </div>
                                              );
                                            }
                                          })}
                                        </div>
                                      </div>
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        height: "100%",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div>
                                        <p
                                          style={{
                                            color: Colors.globalColor8,
                                            fontWeight: "bold",
                                            fontSize: "14px",
                                            textAlign: "left",
                                            marginBottom: "0px",
                                            marginTop: "0px",
                                          }}
                                        >
                                          {row.score ? row.score : 0}%
                                        </p>
                                      </div>
                                      <div>
                                        <Tooltip
                                          title={moment(row.createdAt).format(
                                            "MM/DD/YY"
                                          )}
                                        >
                                          <p style={{ margin: 0 }}>
                                            <EventIcon
                                              style={{
                                                color: Colors.globalColor8,
                                              }}
                                            />
                                          </p>
                                        </Tooltip>
                                      </div>

                                      {row.isCompleted == true && (
                                        <div>
                                          <DoneAllIcon
                                            style={{ color: "green" }}
                                          />
                                        </div>
                                      )}

                                      <div>
                                        <img
                                          src={dotsH}
                                          onClick={(e) => {
                                            setCurrentEditInspection(row.id);
                                            setCurrentEditRow(row);
                                            handleClick2(e);
                                          }}
                                          width={30}
                                          alt="open modal"
                                          style={{
                                            marginTop: "0px",
                                            cursor: "pointer",
                                          }}
                                        />
                                        <Menu
                                          id="simple-menu"
                                          className="extraMenuBox"
                                          anchorEl={anchorEl}
                                          keepMounted
                                          open={Boolean(anchorEl)}
                                          onClose={handleClose2}
                                        >
                                          {currentEditRow?.created_by ==
                                            currentUser?.user_id ||
                                          currentEditRow?.assignees_ids_parsed?.filter(
                                            (v) => v == currentUser.user_id
                                          ).length > 0 ?
                                                <MenuItem
                                                  onClick={() => restoreInspection(currentEditInspection)
                                                  }
                                                >
                                                  <img
                                                    src={restore}
                                                    alt="file"
                                                    width={20}
                                                  />
                                                  &nbsp; Restore Inspection
                                                </MenuItem>: <MenuItem
                                                 disabled
                                                >
                                                  <img
                                                    src={restoreG}
                                                    alt="file"
                                                    width={20}
                                                  />
                                                  &nbsp; Restore Inspection
                                                </MenuItem>}
                                               
                                        </Menu>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                        </div>
                      )}
                      {/* <TablePagination component="div" count={rows.length} rowsPerPage={rowsPerPage} page={page} onChangePage={handleChangePage} onChangeRowsPerPage={handleChangeRowsPerPage} /> */}
                    </div>
                  </Grid>
                )}
              </>
            )}
          </div>
        )}
      </div>
      {isModalOpen && (
        <InspectionPopup
          isModalOpen={currentEditRow}
          currentEditRow={currentEditRow}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}
